import WalletMessageModal from './WalletMessageModal';

export default WalletMessageModal;
